import { LocalLoader } from '@klp/design/Loader';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import type { Theme } from '@material-ui/core';
import { Icon, Paper } from '@material-ui/core';
import React from 'react';

type MappingSummaryBoxProps = {
    title: string;
    value: number;
    icon: React.ReactNode;
    isLoading: boolean;
};

const styles = (theme: Theme) => ({
    paper: {
        flex: '0 1 auto',
    },
    box: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
        padding: theme.spacing(2),
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        '& p': {
            margin: 0,
        },
    },
    value: {
        fontSize: '1.5rem',
    },
    icon: {
        color: theme.palette.secondary.main,
    },
});

export const MappingSummaryBox: React.FC<MappingSummaryBoxProps> = ({
    title,
    value,
    icon,
    isLoading,
}) => {
    const classes = useKlpStyles({}, styles);
    return (
        <Paper className={classes.paper}>
            <LocalLoader isLoading={isLoading}>
                <div className={classes.box}>
                    <Icon className={classes.icon} fontSize="large">
                        {icon}
                    </Icon>
                    <div className={classes.text}>
                        <p className={classes.value}>{value}</p>
                        <p>{title}</p>
                    </div>
                </div>
            </LocalLoader>
        </Paper>
    );
};
